import Commerce from '@chec/commerce.js';

export const commerce = new Commerce("pk_37749a34fac936124a261f8b221d5a9274ca699995d3e");